import styled from "styled-components";

export const PickSelectorContainer = styled.div<{ top: number }>`
  #pick-selector-header {
    position: sticky;
    top: ${({ top }) => (top ? `${top}px` : "0")};
    z-index: 10;
  }

  #pick-selector-main-container {
    min-height: 380px;
    align-items: flex-start;
  }
`;
